"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtrasMotorCarousel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Carousel_1 = require("../../carousel/Carousel");
var services_1 = require("@falcon/services");
var ExrasBannerNcd_1 = require("./ExrasBannerNcd");
var ExrasBannerBreakdownCover_1 = require("./ExrasBannerBreakdownCover");
var ExtrasMotorCarousel = /** @class */ (function (_super) {
    __extends(ExtrasMotorCarousel, _super);
    function ExtrasMotorCarousel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtrasMotorCarousel.prototype.getBanners = function (availableBannersConfig) {
        var banners = [];
        if (!this.props.interaction.policyHolder.ncd.doNotDisclose) {
            banners.push({
                id: 1,
                product: services_1.ProductsEnum.MOTOR,
                name: "ExtrasBannerNcd",
                link: "",
                component: (0, jsx_runtime_1.jsx)(ExrasBannerNcd_1.ExtrasBannerNcd, __assign({}, this.props))
            });
        }
        if (!this.props.interaction.optionalExtras.breakdownCover) {
            banners.push({
                id: 2,
                product: services_1.ProductsEnum.MOTOR,
                name: "ExtrasBannerBreakdownCover",
                link: "",
                component: (0, jsx_runtime_1.jsx)(ExrasBannerBreakdownCover_1.ExtrasBannerBreakdownCover, __assign({}, this.props))
            });
        }
        return banners;
    };
    ExtrasMotorCarousel.prototype.getSettings = function (next) {
        if (next) {
            next({ carouselEnabled: true, });
        }
    };
    return ExtrasMotorCarousel;
}(Carousel_1.Carousel));
exports.ExtrasMotorCarousel = ExtrasMotorCarousel;
//# sourceMappingURL=ExtrasMotorCarousel.js.map